export default {
      id: "map__car_type_trailer-usage",
      viewBox: "0 0 16 29",
      url: __webpack_public_path__ + "img/icons.svg#map__car_type_trailer",
      toString: function () {
        return this.url;
      }
    }